import { render } from "./ProfileIndex.vue?vue&type=template&id=3035d3e8"
import script from "./ProfileIndex.vue?vue&type=script&lang=js"
export * from "./ProfileIndex.vue?vue&type=script&lang=js"

import "./ProfileIndex.vue?vue&type=style&index=0&id=3035d3e8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__